module.exports = __webpack_public_path__ + "img/cg.cd341648.png";